import UtilService from "../services/util.service";

export default {
  name: "toPropercase",
  fn: value => {
    return UtilService.toPropercase(value);
  }
};
